import React from 'react';

import { parseNlToArray, parseTextForHtmlCharacterEntities } from 'utils/formatting';

export function NewLineToParagraph({ note, className }: { note: string; className?: string }) {
  return (
    <div className={className}>
      {parseNlToArray(parseTextForHtmlCharacterEntities(note)).map((line, idx) => (
        <React.Fragment key={`note-line-${idx}`}>
          {line}
          <br />
        </React.Fragment>
      ))}
    </div>
  );
}
